import React from 'react';

import TimeLine from 'components/TimeLine';

import { Translate } from 'core/translate';
import { CancellationPenalties, Price } from 'ProviderRatePlan-Types';

import styles from './cancellationPolicy.module.scss';

type Props = {
  wrapperClassName: string;
  titleClassName: string;
  cancellationPenalties: Array<CancellationPenalties>;
  currency: string;
  language: string;
  price: Price;
};

function CancellationPolicy(props: Props) {
  const {
    wrapperClassName,
    titleClassName,
    cancellationPenalties,
    currency,
    language,
    price,
  } = props;
  return (
    <div className={wrapperClassName} data-testid="cancellationPolicy-wrapper">
      <div className={titleClassName}>
        <Translate id="Cancellation_Policy_Common.Cancellation_Policy_Modal.Section_Title" />
      </div>
      <TimeLine
        cancellationPenalties={cancellationPenalties}
        className={styles.timeline}
        reservationPrice={price.total}
        currency={currency}
        locale={language}
      />
      <Translate
        className={styles.disclaimer}
        id="Provider_Info.Room_List.Plan_Details.Price_Disclaimer"
      />
      <Translate
        className={styles.disclaimer}
        id="Provider_Info.Room_List.Plan_Details.Rate_Disclaimer"
      />
    </div>
  );
}

export default CancellationPolicy;
